const EditStyle = {
  overlay: {
    backdropFilter: 'blur(3px)',
  },
  content: {
    top: '42.5%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    minWidth: '80%',
    backgroundColor: 'grey',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '1em',
    paddingRight: '1em',
    direction: 'rtl',
    overflowY: 'hidden',
  },
};
export default EditStyle;
